import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 1v22h18V9c0-6-2-8-8-8zm13.5 7.6v1.8h-9V8.6zm0 5v1.8h-9v-1.8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
DocumentFilledSize24Glyph.displayName = 'DocumentFilledSize24Glyph';
